const g = require('globals')
const $ = require('lib/jquery')
const Marionette = require('lib/marionette')
const getCachedScript = require('lib/get_cached_script')
const radio = require('lib/radio')
const config = require('lib/config')
const log = require('log').create('auth', 'facebook')  

const channel = radio.auth
const facebook_url = 'https://connect.facebook.net/en_US/all.js'
const default_error_message = 'Facebook user not found. Please try again.'

const Controller = Marionette.MnObject.extend({

    initialize(options) {

        channel.reply('facebook:authorize', this.authorize, this)

        getCachedScript(facebook_url)
            .done(() => this.facebookLoaded())
            .fail(() => this.facebookFailed())
    },

    facebookLoaded() {
        log('facebookLoaded')
        try {
            window.FB.init({
                appId: config.get('pumpkinhead.globals.facebook_app_id'),
                cookie: true,
                xfbml: true,
                version: 'v2.12',
            })
            log('loaded')
            channel.trigger('facebook:loaded')

        } catch {
            log('failed')
            channel.trigger('facebook:failed')
        }
    },

    facebookFailed() {
        channel.trigger('facebook:failed')
    },

    authorize() {
        log('authorize')
        const deferred = $.Deferred()

        if (window.FB) {

            window.FB.login((response) => {
                // If they logged into facebook properly + gave permsissions
                // if necessary, let them login or signup accordingly.
                if (response.status === 'connected') {
                    this.postToFacebook(response, deferred)
                } else {
                    // the user decided not to auth
                    // reject with no data (no message)
                    deferred.reject()
                }

            }, { scope: 'public_profile, email' })

        } else {
            // window.FB doesn't exist
            deferred.reject({
                message: 'The Facebook API is not available. Please try again later.',
            })
        }

        return deferred.promise()
    },

    postToFacebook(response, deferred) {
        // Get the id token to sign them up with & the necessary user info.
        let input
        const authResponse = response.authResponse
        try {
            input = {
                access_token: authResponse.accessToken,
                id_token: authResponse.userID,
            }
        } catch {
            deferred.reject({
                response,
                message: default_error_message,
            })
        }

        $.ajax({
            type: 'POST',
            url: `${g.NODE_API}/social/facebook`,
            data: input,
        })
            .done((output) => {
                deferred.resolve({
                    output,
                    response,
                })
            })
            .fail((output) => {
                deferred.reject({
                    output,
                    response,
                    message: 'We were unable to authorize you via Facebook. Please try another method.',
                })
            })

    },

})

module.exports = Controller
